/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import moment from 'moment';

const notify = css`
  &.notify {
    color: #ffffff;
    .notify__list {
      padding-top: 20px;
      list-style: none;
    }
    .notify__title {
      padding-left: 40px;
    }
    .notify__item {
      padding-bottom: 20px
    }
  }
`; 





const Notifications = ({notifications}) => {
    return (
      <div className="notify pt-5" css={notify}>
            <h5 className="notify__title">Уведомления</h5>
            <div className="card-body p-0">
                <ul className="card-text notify__list">
                    {notifications && notifications.map((item) => {

                        const additionalString =item.pressmark ? `к шифру ${item.pressmark}` : ''

                        return (
                            <li key={item.id} className="notify__item">
                                <span>{item.user}</span> 
                                <span> {item.content} {additionalString}</span>
                                <div className="text-muted">
                                    {moment(item.time.toDate()).fromNow()}
                                </div>                                
                            </li>
                        )    
                    })}
                </ul>
            </div>
        </div>
    )
}

export default Notifications


